import { render } from "./PackageCost.vue?vue&type=template&id=28816aa4&ts=true&lang=pug"
import script from "./PackageCost.vue?vue&type=script&lang=ts"
export * from "./PackageCost.vue?vue&type=script&lang=ts"

import "./PackageCost.vue?vue&type=style&index=0&id=28816aa4&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__